import { StateCreator } from 'zustand';

import {
  handleAddInstagramCommunication,
  handleDeleteInstagramCommunication,
  handleSaveInstagramConversations,
  handleSetConversationCommunications,
  handleSetLoading,
  handleUpdateInstagramCommunication,
} from './handlers';
import { InstagramCommunicationsStore } from './types';

export const createInstagramCommunicationsSlice: StateCreator<
  InstagramCommunicationsStore
> = (set, get) => {
  return {
    conversations: [],
    isLoading: false,
    setLoading: (isLoading) => handleSetLoading(set, isLoading),
    saveInstagramConversations: (conversations) =>
      handleSaveInstagramConversations(set, conversations),
    setConversationCommunications: (conversationId, communications) =>
      handleSetConversationCommunications(
        set,
        get,
        conversationId,
        communications,
      ),
    addInstagramCommunication: (conversationId, communication) =>
      handleAddInstagramCommunication(set, get, conversationId, communication),
    updateInstagramCommunication: (conversationId, messageId, updatedFields) =>
      handleUpdateInstagramCommunication(
        set,
        get,
        conversationId,
        messageId,
        updatedFields,
      ),
    deleteInstagramCommunication: (conversationId, messageId) =>
      handleDeleteInstagramCommunication(set, get, conversationId, messageId),
    resetState: () =>
      set({
        conversations: [],
        isLoading: false,
      }),
  };
};
